import { useAsync } from '@shared/async';

import { postWithValidation } from '@/lib/api-helpers';

type MovePackagingsRequest = {
  drugId: number;
  ndcs: string[];
}

export const useMovePackagings = () => {
  const movePackagings = ({ drugId, ndcs }: MovePackagingsRequest) => {
    const url = `drugs/${drugId}/move-packagings/`;

    return postWithValidation(url, { data: ndcs });
  };

  const movePackagingsAsync = useAsync(movePackagings);

  return {
    ...movePackagingsAsync
  };
};
